import { decamelizeKeys } from "humps";
import { getCookie } from "./cookieUtil";
import {
  UTM_COOKIE_CAMPAIGN_KEY,
  UTM_COOKIE_MEDIUM_KEY,
  UTM_COOKIE_SOURCE_KEY,
} from "../constants/googleAnalyticsConstants";

export const getUtmValues = () => {
  const utmCampaign = getCookie(UTM_COOKIE_CAMPAIGN_KEY);
  const utmMedium = getCookie(UTM_COOKIE_MEDIUM_KEY);
  const utmSource = getCookie(UTM_COOKIE_SOURCE_KEY);

  const values = {
    ...(utmCampaign && { utmCampaign }),
    ...(utmMedium && { utmMedium }),
    ...(utmSource && { utmSource }),
  };

  return decamelizeKeys(values);
};
